var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCookie = function SvgIconCookie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 17.625a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M10.125 15.375a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7.875 11.625a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14.25 11.625a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m21 11.944 1-.015a1.76 1.76 0 0 0-2.129-1.694l-.008.002a2 2 0 0 1-2.438-1.92 1.75 1.75 0 0 0-1.741-1.742 2 2 0 0 1-1.92-2.437l.001-.01A1.76 1.76 0 0 0 12.071 2h-.009a10 10 0 0 0-7.031 17.167c3.898 3.793 10.185 3.752 14.032-.093A9.96 9.96 0 0 0 22 11.937zm-9.244-7.94a8 8 0 0 0-5.33 13.73c3.114 3.03 8.15 2.997 11.223-.075l.002-.002a7.96 7.96 0 0 0 2.346-5.413 4 4 0 0 1-4.562-3.678 4 4 0 0 1-3.679-4.562",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCookie;